import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  filterColumn: null,
  filterValue: null,
};

export const FilterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {

    setFilterColumn: (state, action ) => {
      return { ...state, filterColumn: action.payload };
    },

    setFilterValue: (state, action ) => {
      return { ...state, filterValue: action.payload };
    },

    resetFilter: (state) => {
      return {
        ...state,
        filterColumn: null,
        filterValue: null,
      };
    },
  },
});

export const {
  setFilterColumn,
  setFilterValue,
  resetFilter,
} = FilterSlice.actions;
